import { createSelector } from 'reselect';
import {
  groupBy,
  map,
  mapValues,
  pipe,
  toPairs,
} from 'lodash/fp';
import utils from 'utils';
import { timeframeAll } from './timeframe';
import { infoSelector, dataSelector, geographySelector } from './';

const { number } = utils.sort;

// const sortSelector = createSelector(
//   indicatorSelector,
//   ({ sort: { dir = 'asc', col = '0' } = {} }) => ({ dir, col })
// );

// const countySelector = createSelector(
//   indicatorSelector,
//   ({ counties }) => counties.byId
// );

export const tableSelectorFunc = (
  data,
  geography,
  timeframes,
  info,
  props = {},
) => {
  // Casts to false if props.timeframe is mia
  const activeTimeframes = (
    props.timeframes && !Array.isArray(props.timeframes) ?
      [props.timeframes] :
      props.timeframes
  ) || false;

  // Get all active timeframesAll
  const orderedTimeframes = timeframes
    // Filter out all non-active timeframesAll, if activeTimeframe is set
    .filter((timeframe) => !activeTimeframes ||
      -1 < activeTimeframes.indexOf(timeframe.value) ||
      -1 < activeTimeframes.indexOf(timeframe.label)
    )
    // Sort by number (for now) @TODO: if we have to handle ranges change this sort
    .sort(({ value: a }, { value: b }) => number()(a, b))
    .map(({ label }) => label)
    .reverse();

  const geographyColumnTitle = 'usdata' === info.dataView ?
    'State' : 'Geography';

  const headers = [geographyColumnTitle, ...orderedTimeframes]
    .map((x, idx) => ({
      title: ('usdata' === info.dataView || 0 === idx) ? x : info.shortTitle,
      id: x.toLowerCase(),
      ordinal: idx,
    }));

  // Filter the data by timeframe
  const filteredData = activeTimeframes ?
    data.filter(({ timeframe }) => (
      -1 < activeTimeframes.indexOf(timeframe.label) ||
      -1 < activeTimeframes.indexOf(timeframe.value)
    )) :
    data;

  // Group the data by geography, and then attach an ordinal to the cells based on header ordinal
  const groupedData = pipe([
    groupBy('geography'),
    mapValues((item) => item.map((cell) => ({
      ...cell,
      ordinal: headers
        .find(({ id }) => id === cell.timeframe.label).ordinal,
    })).sort(({ ordinal: a }, { ordinal: b }) => a - b)),
  ])(filteredData);

  // Get remove any geo that isn't active
  const activeGeoData = Object.keys(groupedData).reduce((acc, key) => (
    Object.hasOwnProperty.call(geography, key) ?
      ({ ...acc, [key]: groupedData[key] }) :
      acc
  ), {});

  /**
   * Row Data which table expects, it looks like:
   * [
   *   {
   *      rowId,
   *      data: [// row data
   *        {
   *          idx,
   *          fixed, // optional (left/right/undefined)
   *          align, // optional (left/right/undefined)
   *          formattedValue,
   *        },
   *        ...
   *      ]
   *   },
   *   ...
   * ]
   */
  const rowData = pipe([
    toPairs,
    map(([key, val]) => ({
      rowId: key,
      pin: (
        ('string' === typeof props.pinValue ?
          props.pinValue.toLowerCase() :
          '') ===
        geography[key].geography.toLowerCase()
      ),
      data: [
        {
          idx: 0,
          fixed: 'left',
          align: 'left',
          formattedValue: geography[key].geography,
        },
        ...val.map(({ ordinal, formattedValue }) => ({
          idx: ordinal,
          align: 'right',
          formattedValue,
        })),
      ],
    })),
  ])(activeGeoData);

  const columns = headers.map(({ title, id, ordinal }) => ({
    label: title,
    id,
    idx: ordinal,
    colId: id,
    fixed: (0 === ordinal) ? 'left' : undefined,
  }));

  return {
    columns,
    rowData,
    shortTitle: info.shortTitle,
    title: info.title,
  };
};

// Gotta do this to generate a distinct instance of a selector
// see: https://github.com/reactjs/reselect#sharing-selectors-with-props-across-multiple-components
export const tableSelector = createSelector(
  dataSelector,
  geographySelector,
  timeframeAll,
  infoSelector,
  (state, ownProps) => ownProps, // @TODO dry this up
  tableSelectorFunc
);

export default tableSelector;



// WEBPACK FOOTER //
// ./app/selectors/indicator/table.js